import styled from "styled-components";

const ClientCell = styled.div`
    grid-column-start: ${({ index }) => index + 2};
    ${({ maxWidth }) => maxWidth ? `max-width: ${maxWidth};` : ""}
`;

export default ClientCell;